import React, { useContext, useState, useRef, useEffect } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { Card } from "react-bootstrap"
import TemplateDoc from '../../../templates/sBook/Mantainers/tmp_Contracts.csv'
import { useGetLegalEntities } from "../../../hooks/services/sBook/useOfLegalEntity";
import { useGetClientListBusinessUnits } from "../../../hooks/services/sBook/useOfBusinessUnit";
import { useGetCurrencies } from "../../../hooks/services/sBook/useOfCurrency";
import { useGetCategories, useGetSegments } from "../../../hooks/services/sBook/useOfSegment";
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { useGetContracts, useGetContractsPropsMaintainer, useGetPropsMaintainer } from "../../../hooks/services/sBook/useOfContract";
import { addContract, deleteContract, getContractById, saveAllContracts, saveContractById } from "../../../services/sBook/contract.service";
import { downloadCSV, excelDateToJSDate, getGridLocalization, isNullUndefinedOrEmpty, showMessage } from "../../../common/Helpers";
import { useManipulateTemporalColumns } from "../../../hooks/component/sKPI/useOfContract";
import { useSelector } from "react-redux";
import SidePanelConfigureProps from "./SidePanelConfigureProps";
import { __CONTRACT_STATUS, __MessageTypes } from "../../../common/Dictionaries";
import MessageBox from "../../../components/Common/Message/MessageBox";
import MainAppContext from "../../../MainAppContext";
import * as XLSX from 'xlsx';
import MatrixToolbar from "../../../components/Products/sPrivilege/Matrix/MatrixToolbar";
import { IconButton } from "@fluentui/react";
import moment from "moment";
import { applyFilters, cellRenderClassStyle, executeScrollMovementToFixLockRowOnEditCell, handlerFilter, removeGridLocalStorageFilters, setterActionFired, useFilterActionComponentData } from "../../../common/Helpers/JqxGridFilter";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
export default function Contract(props) {
    const { t } = useTranslation();
    const { _contractProps: listContractsProps } = useSelector((state) => state.maintainerScope);
    const { _contractPropListValues: listContractsPropValues } = useSelector((state) => state.maintainerScope);
    const [isPanelConfigurePropsOpen, setIsPanelConfigurePropsOpen] = useState(false);
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)

    const gridRef = useRef();
    const fileInputRef = useRef(null);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [forceListMerge, setForceListMerge] = useState(false);
    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);
    const [editingRows, setEditingRows] = useState([]);

    const [listLegalEntities, setListLegalEntities] = useState(null);
    useGetLegalEntities(listLegalEntities, setListLegalEntities)

    const [listBusinessUnit, setListBusinessUnit] = useState(null);
    useGetClientListBusinessUnits(listBusinessUnit, setListBusinessUnit)
    
    const [listCurrencies, setListCurrencies] = useState(null);
    useGetCurrencies(listCurrencies, setListCurrencies)

    const [listSegments, setListSegments] = useState(null);
    useGetSegments(listSegments, setListSegments)

    const [listCategories, setListCategories] = useState(null);
    useGetCategories(listCategories, setListCategories)

    const [temporalListContracts, setTemporalListContracts] = useState(null);
    useGetContracts(temporalListContracts, setTemporalListContracts);

    const listStatus = __CONTRACT_STATUS.map(x => { return { key: x.key, text: t(x.value) } });

    useGetContractsPropsMaintainer(listContractsProps);
    useGetPropsMaintainer(listContractsPropValues);

    const [listContracts, setListContracts] = useState(null);
    useManipulateTemporalColumns(listContractsProps, temporalListContracts, setListContracts, forceListMerge);

    useFilterActionComponentData(gridRef, messageConfig, "Contract");

    useEffect(() => {
        if (listContracts === null) {
            removeGridLocalStorageFilters("Contract")
        }

    }, [listContracts]);

    const onGetTemplateClick = (type) => {
        const linkExport = document.getElementById("btnGetTemplateJson");
        let exportFileName = "";
        let excelStrData = "Id;Name\n";
        
        switch (type) {
            case "LE":
                exportFileName = t('data-lang-lbl-legalentity') + ".csv";
                listLegalEntities.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;

            case "BU":
                exportFileName = t('data-lang-lbl-businessunit') + ".csv";
                listBusinessUnit.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;

            case "Segment":
                exportFileName = t('data-lang-lbl-segment') + ".csv";
                listSegments.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;

            case "Currency":
                exportFileName = t('data-lang-lbl-currency') + ".csv";
                listCurrencies.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;

            case "Category":
                exportFileName = t('data-lang-lbl-category') + ".csv";
                listCategories.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            
            default:
                break
        }
    };

    const validateObject = (object) => {
        let isValid = !isNullUndefinedOrEmpty(object.name);
        isValid = isValid ? !isNullUndefinedOrEmpty(object.contractCode) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.startDate) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.endDate) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.legalEntityBuyerId) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.legalEntitySupplierId) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.businessUnitId) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.segmentId) : isValid;
        //[##]Área de backoffice indica que es opcional.
        //isValid = isValid ? !isNullUndefinedOrEmpty(object.categoryId) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.currencyId) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.adminUsername) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.amount) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.endowment) : isValid;
        isValid = isValid ? !isNullUndefinedOrEmpty(object.statusId) : isValid;
        //isValid = isValid ? !isNullUndefinedOrEmpty(object.scope) : isValid;

        const listCustomProps = Object.keys(object).filter(key => key.startsWith('custom_')).map(key => ({
            key: key,
            value: object[key]
        }));

        listCustomProps.forEach(prop => {
            const propFieldEncodedValues = prop.key.split('_');
            const customContractProp = listContractsProps.find(x => x.id === parseInt(propFieldEncodedValues[1]))
            if (customContractProp.required === true) {
                isValid = isValid ? !isNullUndefinedOrEmpty(prop.value) : isValid;
            }
        });

        if (isValid) {
            const startDate = moment(object.startDate);
            const endDate = moment(object.endDate);
            const dateDiff = startDate.diff(endDate);
        
            if (dateDiff > 0) {   
                isValid = false;
            }
        }

        return isValid;
    };

    const handlerSaveAll = async () => {
        const gridItems = gridRef.current.props.source.records.filter(x => x.id <= 0);

        const new_list = []

        gridItems.forEach(gridItem => {
            const aux_item = listContracts.find(x => x.id === gridItem.id)

            listContractsProps.forEach(prop => {
                aux_item.cellRenderClassStylel_props.forEach(contractProp => {
                    switch (prop.valType) {
                        case 'str':
                            contractProp.strVal = gridItem[("custom_" + prop.id + "_" + prop.valType + "_" + prop.shortName)]
                            break;
                        case 'num':
                            contractProp.numVal = gridItem[("custom_" + prop.id + "_"  + prop.valType + "_" + prop.shortName)]
                            break;
                        case 'list':
                            contractProp.cplId = gridItem[("custom_" + prop.id + "_"  + prop.valType + "_" + prop.shortName)]
                            break;
                        default:
                            break;
                    }
                });
            });

            new_list.push({
                "id": gridItem.id,
                "contractNemo": "",
                "contractCode": gridItem.contractCode,
                "name": gridItem.name,

                "legalEntityBuyerId": gridItem.legalEntityBuyerId,
                "legalEntityBuyerName": gridItem.LegalEntityBuyer_Id,
                "legalEntityBuyerCode": "",

                "legalEntitySupplierId": gridItem.legalEntitySupplierId,
                "legalEntitySupplierName": gridItem.LegalEntitySupplier_Id,
                "legalEntitySupplierCode": "",

                "businessUnitId": gridItem.businessUnitId,
                "businessUnitName": gridItem.BusinessUnit_Id,

                "segmentId": gridItem.segmentId,
                "segmentName": gridItem.Segment_Id,

                "categoryId": gridItem.categoryId,
                "categoryName": gridItem.Category_Id,

                "currencyId": gridItem.currencyId,
                "currencyName": gridItem.Currency_Id,
                
                "startDate": moment(gridItem.startDate).toISOString(),
                "endDate": moment(gridItem.endDate).toISOString(),
                "adminUsername": gridItem.adminUsername,
                "amount": gridItem.amount,
                "endowment": gridItem.endowment,
                "statusId": gridItem.statusId,
                "scope": gridItem.scope,
                "l_props": aux_item.l_props
            })
        });

        await saveAllContracts(new_list).then((serviceResponse) => {
            if (serviceResponse.data.succeeded) {
                setTemporalListContracts(null)
                setListContracts(null)
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
            setterActionFired("Contract", 1)
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setterActionFired("Contract", 1)
        });
    };

    const handlerDelete = async (itemId) => {
        if (itemId <= 0) {
            const newListContracts = listContracts.filter(x => x.id !== itemId);
            setListContracts(newListContracts)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("Contract", 1)
        }
        else {
            await deleteContract(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const newListContracts = listContracts.filter(x => x.id !== itemId);
                    setListContracts(newListContracts)
                    setEditingRows(editingRows.filter(x => x !== itemId));

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    if (serviceResponse.data.message.startsWith('data-lang-')) {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(serviceResponse.data.message))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }
                setterActionFired("Contract", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("Contract", 1)
            });
        }
    };

    const handlerSave = async (itemId, listContractsProps) => {
        const item = gridRef.current.props.source.records.find(x => parseInt(x.id) === itemId);
        const isValid = validateObject(item);
        if (isValid) {
            if (itemId <= 0) {
                item.l_props = [];

                if (listContractsProps !== null) {
                    listContractsProps.forEach(prop => {
                        let _prop = {
                            id:0,
                            contractPropId: prop.id,
                            contractId: item.id,
                            strVal: null,
                            numVal:null,
                            cplId: null
                        }

                        switch (prop.valType) {
                            case 'str':
                                _prop.strVal = item[("custom_"  + prop.id + "_" + prop.valType + "_" + prop.shortName)];
                                break;
                            case 'num':
                                _prop.numVal = item[("custom_" + prop.id + "_" + prop.valType + "_" + prop.shortName)];
                                break;
                            case 'list':
                                _prop.cplId = item[("custom_" + prop.id + "_" + prop.valType + "_" + prop.shortName)];
                                break;
                            default:
                                break;
                        }

                        item.l_props.push(_prop)
                    })
                }

                const newItem =
                {
                    "id": item.id,
                    "contractNemo": "",
                    "contractCode": item.contractCode,
                    "name": item.name,

                    "legalEntityBuyerId": item.legalEntityBuyerId,
                    "legalEntityBuyerName": item.LegalEntityBuyer_Id,
                    "legalEntityBuyerCode": "",

                    "legalEntitySupplierId": item.legalEntitySupplierId,
                    "legalEntitySupplierName": item.LegalEntitySupplier_Id,
                    "legalEntitySupplierCode": "",

                    "businessUnitId": item.businessUnitId,
                    "businessUnitName": item.BusinessUnit_Id,

                    "segmentId": item.segmentId,
                    "segmentName": item.Segment_Id,

                    "categoryId": item.categoryId,
                    "categoryName": item.Category_Id,

                    "currencyId": item.currencyId,
                    "currencyName": item.Currency_Id,

                    "startDate": moment(item.startDate).toISOString(),
                    "endDate": moment(item.endDate).toISOString(),
                    "adminUsername": item.adminUsername,
                    "amount": item.amount,
                    "endowment": item.endowment,
                    "scope": item.scope,
                    "statusId": item.statusId,
                    "l_props": item.l_props
                }

                await addContract(newItem).then((serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))
                        
                        listContracts.forEach(element => {
                            if (element.id === parseInt(item.id)) {
                                element.id = serviceResponse.data.data.id;
                                element.contractCode = serviceResponse.data.data.contractCode;
                            }
                        });

                        setListContracts(listContracts);
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(serviceResponse.data.message))
                    }
                    setterActionFired("Contract", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("Contract", 1)
                });
            }
            else {
                const aux_item = listContracts.find(x => x.id === item.id);
                
                if (listContractsProps !== null) {
                    aux_item.businessUnitId = item.businessUnitId;
                    aux_item.categoryId = item.categoryId;
                    aux_item.contractCode = item.contractCode;
                    aux_item.currencyId = item.currencyId;
                    aux_item.endDate = item.endDate;
                    aux_item.legalEntityBuyerId = item.legalEntityBuyerId;
                    aux_item.legalEntitySupplierId = item.legalEntitySupplierId;
                    aux_item.name = item.name;
                    aux_item.segmentId = item.segmentId;
                    aux_item.startDate = item.startDate;
                    aux_item.statusId = item.statusId;
                    aux_item.endowment = item.endowment;
                    aux_item.amount = item.amount;
                    aux_item.adminUsername = item.adminUsername;
                    aux_item.scope = item.scope;
                    aux_item.statusId = item.statusId;
                    aux_item.businessUnitName = item.businessUnitName;
                    aux_item.segmentName = item.segmentName;
                    aux_item.legalEntitySupplierName = item.legalEntitySupplierName;
                    aux_item.legalEntityBuyerName = item.legalEntityBuyerName;
                    aux_item.currencyName = item.currencyName;
                    aux_item.categoryName = item.categoryName;
                    aux_item.businessUnitName = item.businessUnitName;

                    aux_item.l_props.forEach(contractProp => {
                        const prop = listContractsProps.find(x => x.id === contractProp.contractPropId )
                        switch (prop.valType) {
                            case 'str':
                                contractProp.strVal = item[("custom_" + prop.id + "_" + prop.valType + "_" + prop.shortName)]
                                break;
                            case 'num':
                                contractProp.numVal = item[("custom_"  + prop.id + "_" + prop.valType + "_" + prop.shortName)]
                                break;
                            case 'list':
                                contractProp.cplId = item[("custom_" + prop.id + "_" + prop.valType + "_" + prop.shortName)]
                                break;
                            default:
                                break;
                        }
                    });
                }

                await saveContractById(itemId, aux_item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))   
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(serviceResponse.data.message))
                    }
                    setterActionFired("Contract", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("Contract", 1)
                });
            }

            setShowRequiredGlobalMessage(false);
        }
        else {
            setShowRequiredGlobalMessage(true);
        }
    };

    const handlerCancel = async (itemId) => {
        if (itemId === null) {
            const newListContracts = listContracts.filter(x => x.id !== itemId);
            setListContracts(newListContracts)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("Contract", 1)
        }
        else {
            await getContractById(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    listContracts.forEach(element => {
                        if (serviceResponse.data.data.id === element.id) {
                            for (const property in serviceResponse.data.data) {
                                element[property] = serviceResponse.data.data[property]
                            }
                        }
                    });
            
                    setListContracts(listContracts);
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("Contract", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("Contract", 1)
            });
        }
    };

    const getCustomPropFieldType = (fieldName) => {
        if (fieldName.indexOf('custom_') !== -1 && fieldName.indexOf('_num_') !== -1) {
            return 'num'
        }
        else if (fieldName.indexOf('custom_') !== -1 && fieldName.indexOf('_str_') !== -1) {
            return 'str'
        }
        else if (fieldName.indexOf('custom_') !== -1 && fieldName.indexOf('_list_') !== -1) {
            return 'list'
        }
        else {

        }
    };

    const handlerAddNewRow = (obj, _listContractsProps) => {
        const _lowerId = listContracts.length !== 0 ? listContracts.reduce((min, obj) => obj.id < min ? obj.id : min, listContracts[0].id) : 0;
        const lowerId = listContracts.length === 0 ? -1 : (_lowerId > 0 ? ((_lowerId * -1) - 1) : _lowerId -1);

        let newRow = {};

        if (!obj) {
            newRow = {
                id:                     lowerId,
                name:                   "",
                contractCode:           "",
                contractNemo:           "",
                adminUsername:          "",
                businessUnitId:         null,
                currencyId:             null,
                legalEntityBuyerId:     null,
                legalEntitySupplierId:  null,
                segmentId:              null,
                categoryId:             null,
                startDate:              null,
                endDate:                null,
                endowment:              null,
                amount:                 null,
                scope:                  "",
                statusId:               0,
                l_props:                []
            }

            _listContractsProps.forEach(prop => {
                newRow.l_props.push({
                    id: prop.id,
                    contractPropId: prop.id,
                    contractId: newRow.id,
    
                    cplId: null,
                    cplVal: null,
                    numVal: null,
                    strVal: null
                })
            });
        }
        else {
            newRow.l_props = [];

            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (key === "startDate" || key === "endDate") {
                        newRow[key] = moment(obj[key]).format('DD-MM-YYYY');
                    }
                    else if ((key.indexOf('custom_') !== -1) && ((key.indexOf('_num_') !== -1) || (key.indexOf('_str_') !== -1) || (key.indexOf('_list_') !== -1))) {
                        const customPropId = parseInt(key.split('_')[1]);
                        const customPropFieldType = getCustomPropFieldType(key);

                        newRow[key] = obj[key];
                        newRow.l_props.push({
                            id: customPropId,
                            contractPropId: customPropId,
                            contractId: newRow.id,
            
                            cplId: null,
                            cplVal: (customPropFieldType === "list") ? obj[key] : null,

                            numVal: (customPropFieldType === "num") ? obj[key] : null,
                            strVal: (customPropFieldType === "str") ? obj[key] : null
                        })
                    }
                    else {
                        newRow[key] = obj[key];
                    }
                }
            }

            newRow.id = lowerId;
        }


        gridRef.current.beginupdate();
        gridRef.current.addrow(null, newRow, 'first');

        listContracts.unshift(newRow);
        setListContracts(listContracts);

        if (editingRows.length > 0 ? editingRows.find(x => x === lowerId) === undefined : true) {
            editingRows.push(lowerId)
            setEditingRows(editingRows);
        }

        gridRef.current.endupdate();
        gridRef.current.updatebounddata('rows');
        setterActionFired("Contract", 1)
    };

    const handlerUploadData = () => {
        fileInputRef.current.click();
    };

    const handlerFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const convertedData = jsonData.slice(1).map((row, rowIndex) => {
                const convertedRow = {};
                convertedRow.l_props = []
                
                row.forEach((cell, columnIndex) => {
                    const columnName = getColumns().find(x => x.index === columnIndex).dataField;
                    const dateFields = ["startDate", "endDate"];
                    
                    convertedRow[columnName] = dateFields.includes(columnName) ? excelDateToJSDate(cell) : cell;                });
                    convertedRow.id = null;

                return convertedRow;
            });

            convertedData.forEach(element => {
                handlerAddNewRow(element, listContractsProps)
            });
        };

        reader.readAsArrayBuffer(file);
        fileInputRef.current.value = '';
    };

    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => x.key === row[column.dataField])

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.text : "";
    };

    const handlerExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();

        const aux_rows = []

        if (exportData) {
            const aux_list = listContracts.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                getColumns().forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: getColumns().filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        if (exportData) {
            XLSX.writeFile(workbook, 'Contract_ExportedData.xlsx');
        }
        else {
            XLSX.writeFile(workbook, 'Contract_UploadTemplate.xlsx');
        }
    };

    const onOpenConfigurePropsPanel = () => {
        setIsPanelConfigurePropsOpen(true)
        showMessage(setMessageConfig, false, __MessageTypes.SUCCESS, null)
        setterActionFired("Contract", 1)
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'textbox':
                switch (subType) {
                    case "currency":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: false,
                            symbol: '$',
                            groupSeparator: '.',
                            decimalSeparator: ',',
                            digits: 19, 
                            max: 9999999999999,
                        });
                        break;
                    case "number":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: true,
                            groupSeparator: '.',
                            decimalSeparator: ',',
                            digits: 19, 
                            max: 9999999999999,
                        });
                        break;
                    case "numberNoDecimal":
                        editor.jqxNumberInput({
                            decimalDigits: 0,
                            width: width,
                            spinButtons: true,
                            groupSeparator: '.',
                            decimalSeparator: ',',
                            digits: 19, 
                            min: 0,
                            max: 9999999999999,
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 'datetimeinput':
                break;
            case 'checkbox':
                editor.jqxCheckBox({ width: width });
                break;
            case 'dropdownlist':
                editor.jqxDropDownList({
                    width: width,
                    height: height,
                    source: getListColumnAdapter(auxListData, 'key', 'text'),
                    displayMember: 'text',
                    valueMember: 'key',
                    autoDropDownHeight: auxListData.length < 5
                });
                break;
            default:
                break;
        }
    };

    const onCellvaluechanged = (e) => {
        const currentColumn = e.owner._columns.find(x => x.datafield === e.args.datafield);

        if (currentColumn.columntype === "dropdownlist") {
            listContracts[e.args.rowindex][e.args.datafield] = e.args.value.value
        }
        else {
            listContracts[e.args.rowindex][e.args.datafield] = e.args.value
        }

        const copia_listContracts = JSON.parse(JSON.stringify(listContracts));
        setListContracts(copia_listContracts);

        if (editingRows.find(x => x === listContracts[e.args.rowindex].id) === undefined) {
            editingRows.push(listContracts[e.args.rowindex].id)
        }

        setEditingRows(editingRows);
        applyFilters(gridRef, 'Contract', false);

        executeScrollMovementToFixLockRowOnEditCell(gridRef);
    };

    const getListColumnAdapter = (listObjetcs, key, text) => {
        return new jqx.dataAdapter({
            datafields: [
                { name: text, type: 'string' },
                { name: key, type: 'number' }
            ],
            datatype: 'array',
            localdata: listObjetcs
        }, { autoBind: true });
    };

    const getColumns = () => {
        const basicColumns = [
            { index: null, text: 'ID',                           dataField: 'id',                   uploadMasive: false, exportable: false, width: '0px',   columntype: 'textbox', editable: false, hidden: true },
            { index: null, text: t('data-lang-lbl-actions'),     dataField: 'acciones',             uploadMasive: false, exportable: false, width: '100px', pinned: true,
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            },
            { index: 0,    text: t('data-lang-lbl-code'),        dataField: 'contractCode',         uploadMasive: true,  exportable: true,  width: '150px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,              'textbox', 'string'),                      columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox', listContracts),       editable: profileHasAccess, pinned: true },
            { index: 1,    text: t('data-lang-lbl-name'),        dataField: 'name',                 uploadMasive: true,  exportable: true,  width: '200px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,              'textbox', 'string'),                      columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox', listContracts),       editable: profileHasAccess, pinned: true },
            
            { index: 2,    text: t('data-lang-lbl-startdate'),   dataField: 'startDate',            uploadMasive: true,  exportable: true,  width: '200px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,              'datetimeinput'),                          columntype: 'datetimeinput',  cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'datetimeinput', listContracts), editable: profileHasAccess, cellsformat: 'dd-MM-yyyy' },
            { index: 3,    text: t('data-lang-lbl-enddate'),     dataField: 'endDate',              uploadMasive: true,  exportable: true,  width: '200px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,              'datetimeinput'),                          columntype: 'datetimeinput',  cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'datetimeinput', listContracts), editable: profileHasAccess, cellsformat: 'dd-MM-yyyy' },
            
            { index: 4,    text: t('data-lang-lbl-buyer'),       dataField: 'legalEntityBuyerId',   uploadMasive: true,  exportable: true,  width: '300px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listLegalEntities.filter(x => x.type !== 3 && x.type !== 4), 'dropdownlist'), columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist', listContracts),  editable: profileHasAccess, displayfield: 'LegalEntityBuyer_Id', editorOptions: listLegalEntities.filter(x => x.type !== 3 && x.type !== 4) },
            { index: 5,    text: t('data-lang-lbl-supplier'),    dataField: 'legalEntitySupplierId',uploadMasive: true,  exportable: true,  width: '300px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listLegalEntities.filter(x => x.type === 3 || x.type === 4), 'dropdownlist'), columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist', listContracts),  editable: profileHasAccess, displayfield: 'LegalEntitySupplier_Id', editorOptions: listLegalEntities.filter(x => x.type === 3 || x.type === 4) },
            { index: 6,    text: t('data-lang-lbl-businessunit'),dataField: 'businessUnitId',       uploadMasive: true,  exportable: true,  width: '300px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listBusinessUnit,  'dropdownlist'),                           columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist', listContracts),  editable: profileHasAccess, displayfield: 'BusinessUnit_Id', editorOptions: listBusinessUnit },
            { index: 7,    text: t('data-lang-lbl-segment'),     dataField: 'segmentId',            uploadMasive: true,  exportable: true,  width: '100px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listSegments,      'dropdownlist'),                           columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist', listContracts),  editable: profileHasAccess, displayfield: 'Segment_Id', editorOptions: listSegments },
            { index: 8,    text: t('data-lang-lbl-category'),    dataField: 'categoryId',           uploadMasive: true,  exportable: true,  width: '150px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listCategories,    'dropdownlist'),                           columntype: 'dropdownlist',   editable: profileHasAccess, displayfield: 'Category_Id', editorOptions: listCategories },
            { index: 9,    text: t('data-lang-lbl-currency'),    dataField: 'currencyId',           uploadMasive: true,  exportable: true,  width: '150px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listCurrencies,    'dropdownlist'),                           columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist', listContracts),  editable: profileHasAccess, displayfield: 'Currency_Id', editorOptions: listCurrencies },
            { index: 10,   text: t('data-lang-lbl-username'),    dataField: 'adminUsername',        uploadMasive: true,  exportable: true,  width: '250px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,              'textbox', 'string'),                      columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox', listContracts),       editable: profileHasAccess },
            
            { index: 11,   text: t('data-lang-lbl-amount'),      dataField: 'amount',               uploadMasive: true,  exportable: true,  width: '200px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,              'textbox', 'number'),                      columntype: 'numberinput',    cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'numberinput', listContracts),   editable: profileHasAccess, cellsformat: 'd3', cellsalign: 'right' },
            { index: 12,   text: t('data-lang-lbl-endowment'),   dataField: 'endowment',            uploadMasive: true,  exportable: true,  width: '100px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,              'textbox', 'numberNoDecimal'),             columntype: 'numberinput',    cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'numberinput', listContracts),   editable: profileHasAccess, cellsformat: 'd', cellsalign: 'right' },
            { index: 13,   text: t('data-lang-lbl-scope'),       dataField: 'scope',                uploadMasive: true,  exportable: true,  width: '200px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,              'textbox', 'string'),                      columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox',      listContracts),  editable: profileHasAccess },
            { index: 14,   text: t('data-lang-lbl-status'),      dataField: 'statusId',             uploadMasive: true,  exportable: true,  width: '100px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listStatus,        'dropdownlist'),                           columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist', listContracts),  editable: profileHasAccess, displayfield: 'Status_Id', editorOptions: listStatus },                 
        ]
    
        let maxIndex = basicColumns.reduce((max, item) => {
          return item.index > max ? item.index : max;
        }, 0) + 1;
    
        const dynamicColumns = listContractsProps.filter(x => x.deactivate === false).map(column => {
            let object = null
          
            if (listContracts.length > 0) {       
                if (column.valType === "str") {
                    if (column.required) {
                        object = { index: maxIndex, text: column.name, dataField: `custom_${column.id}_${column.valType}_${column.shortName}`, uploadMasive: true, exportable: true, width: '200px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox', listContracts), editable: profileHasAccess };
                    }
                    else {
                        object = { index: maxIndex, text: column.name, dataField: `custom_${column.id}_${column.valType}_${column.shortName}`, uploadMasive: true, exportable: true, width: '200px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox', editable: profileHasAccess };
                    }
                }
                else if (column.valType === "num") {
                    if (column.required) {
                        object = { index: maxIndex, text: column.name, dataField: `custom_${column.id}_${column.valType}_${column.shortName}`, uploadMasive: true, exportable: true, width: '200px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'number'), columntype: 'numberinput', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'numberinput', listContracts), editable: profileHasAccess, cellsformat: 'd3', cellsalign: 'right' };
                    }
                    else {
                        object = { index: maxIndex, text: column.name, dataField: `custom_${column.id}_${column.valType}_${column.shortName}`, uploadMasive: true, exportable: true, width: '200px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'number'), columntype: 'numberinput', editable: profileHasAccess, cellsformat: 'd3', cellsalign: 'right' };
                    }
                }
                else if (column.valType === "list") {
                    const aux_list = listContractsPropValues.filter(x => x.contractPropId === column.id);
                    if (column.required) {
                        object = { index: maxIndex, text: column.name, dataField: `custom_${column.id}_${column.valType}_${column.shortName}`, uploadMasive: true, exportable: true, width: '300px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, aux_list.map(x => {return {key: x.id, text: x.name}}), 'dropdownlist'), columntype: 'dropdownlist', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist', listContracts), editable: profileHasAccess, displayfield: `Custom_${column.id}_${column.valType}_${column.shortName}`, editorOptions: aux_list.map(x => {return {key: x.id, text: x.name}}) };
                    }
                    else {
                        object = { index: maxIndex, text: column.name, dataField: `custom_${column.id}_${column.valType}_${column.shortName}`, uploadMasive: true, exportable: true, width: '300px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, aux_list.map(x => {return {key: x.id, text: x.name}}), 'dropdownlist'), columntype: 'dropdownlist', editable: profileHasAccess, displayfield: `Custom_${column.id}_${column.valType}_${column.shortName}`, editorOptions: aux_list.map(x => {return {key: x.id, text: x.name}}) };
                    }
                }
                else {
                    if (column.required) {
                        object = { index: maxIndex, text: column.name, dataField: `custom_${column.id}_${column.valType}_${column.shortName}`, uploadMasive: true, exportable: true, width: '200px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox', listContracts), editable: profileHasAccess };
                    }
                    else {
                        object = { index: maxIndex, text: column.name, dataField: `custom_${column.id}_${column.valType}_${column.shortName}`, uploadMasive: true, exportable: true, width: '200px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox', editable: profileHasAccess };
                    }
                }
            }
    
            maxIndex = maxIndex + 1;
          
            return object
        });
    
        const finalColumns = basicColumns.concat(dynamicColumns);
    
        return finalColumns;
    };

    const getDataFields = () => {
        const basicDataFields = [
            { name: 'id',                    type: 'number' },
            { name: 'contractCode',          type: 'string' },
            { name: 'name',                  type: 'string' },
            { name: 'startDate',             type: 'date' },
            { name: 'endDate',               type: 'date' },

            { name: 'legalEntityBuyerId',    type: 'number' },
            { name: 'LegalEntityBuyer_Id',    value: 'legalEntityBuyerId', values: { source: listLegalEntities, value: 'key', name: 'text' } },

            { name: 'legalEntitySupplierId', type: 'number' },
            { name: 'LegalEntitySupplier_Id', value: 'legalEntitySupplierId', values: { source: listLegalEntities, value: 'key', name: 'text' } },
            
            { name: 'businessUnitId',        type: 'number' },
            { name: 'BusinessUnit_Id',        value: 'businessUnitId', values: { source: listBusinessUnit, value: 'key', name: 'text' } },
            
            { name: 'segmentId',             type: 'number' },
            { name: 'Segment_Id',             value: 'segmentId', values: { source: listSegments, value: 'key', name: 'text' } },
            
            { name: 'categoryId',            type: 'number' },
            { name: 'Category_Id',            value: 'categoryId', values: { source: listCategories, value: 'key', name: 'text' } },

            { name: 'currencyId',            type: 'number' },
            { name: 'Currency_Id',            value: 'currencyId', values: { source: listCurrencies, value: 'key', name: 'text' } },

            { name: 'adminUsername',         type: 'string' },
            { name: 'amount',                type: 'float' },
            { name: 'endowment',             type: 'number' },

            { name: 'scope',                 type: 'string' },

            { name: 'statusId',              type: 'number' },
            { name: 'Status_Id',              value: 'statusId', values: { source: listStatus, value: 'key', name: 'text' } },
        ]

        const dynamicDataFields = listContractsProps.map(column => {
            let object = null;

            if (column.valType === "str") {
                object = { name: `custom_${column.id}_${column.valType}_${column.shortName}`, type: 'string' };
            }
            else if (column.valType === "num") {
                object = { name: `custom_${column.id}_${column.valType}_${column.shortName}`, type: 'float' };
            }
            else if (column.valType === "list") {
                const aux_list = listContractsPropValues.filter(x => x.contractPropId === column.id)
                object = { name: `Custom_${column.id}_${column.valType}_${column.shortName}`, value: `custom_${column.id}_${column.valType}_${column.shortName}`, values: { source: aux_list.map(x => {return {key: x.id, text: x.name}}), value: 'key', name: 'text' } };
            }
            else {
                object = { name: `custom_${column.id}_${column.valType}_${column.shortName}`, type: 'string' };
            }
    
            return object;
        });

        const dynamicDataFieldsDropdownAditional = listContractsProps.filter(x => x.valType === "list").map(column => {
            let object = null;
            if (column.valType === "list") {
                object = { name: `custom_${column.id}_${column.valType}_${column.shortName}`, type: 'number' };
            }
    
            return object;
        });

        let finalDataFields = basicDataFields.concat(dynamicDataFieldsDropdownAditional);
        finalDataFields = finalDataFields.concat(dynamicDataFields);
    
        return finalDataFields
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'save':
                handlerSave(itemId, listContractsProps)
                break;
            case 'delete':
                handlerDelete(itemId)
                break;
            case 'cancel':
                handlerCancel(itemId)
                break;
            default:
                break;
        }
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listContracts[rowIndex.boundindex].id;
        }
        return listContracts[rowIndex]?.id;
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const isEditing = editingRows.find(x => x === itemId);
        const rowIndex = 0;
        return  <>
                {
                    profileHasAccess &&
                    <>
                        {isEditing ? (
                            <>
                                {
                                    itemId <= 0 ? (
                                        <>
                                            <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                        </>
                                    ) : (
                                        <>
                                            <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                            <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                        </>
                                    )
                                }
                            </>
                        ) : (
                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                        )}
                    </>
                }
                </>
        
    };

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-contracts')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body style={{width: "100%"}} className="access-per-month-form-body h-100 overflow-hidden-deprecated">  
                    <div className="align-items-center h-100">
                        {
                            listLegalEntities && listCurrencies && listSegments && listCategories && listContracts && listBusinessUnit && listContractsPropValues &&
                            <>
                                <div className="d-none">
                                    <input ref={fileInputRef} type="file" accept=".xlsx" onChange={(event) => handlerFileUpload(event)} />
                                    <a id="btnGetTemplate" href={TemplateDoc} download="ContractTemplate.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                                    <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                                </div>
                                <MatrixToolbar
                                    inputParam_HandleSaveData={handlerSaveAll}
                                    inputParam_HandleUploadData={handlerUploadData}
                                    inputParam_HandleExportData={handlerExportData}
                                    inputParam_HandleAddRow={handlerAddNewRow}
                                    inputParam_Configuration={{
                                        buttons: {
                                            showRowButtons: profileHasAccess,
                                            showExportData: true,
                                            showAddMasiveData: profileHasAccess,
                                            showAddData: profileHasAccess,
                                            showDownloadTemplate: profileHasAccess,
                                            showSaveAllData: profileHasAccess,
                                            saveAllDataText: t('data-lang-btn-saveallnewdata'),
                                            groupedButtons: profileHasAccess
                                        },
                                        handlers: {
                                            handlerSave: profileHasAccess ? handlerSave : null,
                                            handlerSaveAll: profileHasAccess ? handlerSaveAll : null,
                                            handlerDelete: profileHasAccess ? handlerDelete : null,
                                            handlerCancel: profileHasAccess ? handlerCancel : null,
                                        },
                                        auxiliarListCallbackOnAdd: null,
                                    }}
                                    inputParam_ExternalExportTemplates={[
                                        {
                                            id: 'btnMantGetTemplate',
                                            key: 'btnMantGetTemplate',
                                            text: t('data-lang-lbl-uploadtemplate'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => handlerExportData(false)
                                        },
                                        {
                                            id: 'btnMantGetTemplateLE',
                                            key: 'btnMantGetTemplateLE',
                                            text: t('data-lang-lbl-legalentity'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('LE')
                                        },
                                        {
                                            id: 'btnMantGetTemplateBU',
                                            key: 'btnMantGetTemplateBU',
                                            text: t('data-lang-lbl-businessunit'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('BU')
                                        },
                                        {
                                            id: 'btnMantGetTemplateSegment',
                                            key: 'btnMantGetTemplateSegment',
                                            text: t('data-lang-lbl-segment'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('Segment')
                                        },
                                        {
                                            id: 'btnMantGetTemplateCurrency',
                                            key: 'btnMantGetTemplateCurrency',
                                            text: t('data-lang-lbl-currency'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('Currency')
                                        },
                                        {
                                            id: 'btnMantGetTemplateCategory',
                                            key: 'btnMantGetTemplateCategory',
                                            text: t('data-lang-lbl-category'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('Category')
                                        },
                                    ]}
                                    inputParam_CustomOpenPanel={onOpenConfigurePropsPanel}
                                    showRequiredMessage={showRequiredGlobalMessage}
                                />
                                <JqxGrid
                                    ref={gridRef}
                                    altrows={true}
                                    enabletooltips={true}
                                    width={'100%'}
                                    theme={'light'} 
                                    height={'500px'}
                                    editable={true}
                                    sortable={true}
                                    filterable={true}
                                    showfilterrow={true} 
                                    localization={getGridLocalization(t)}
                                    source={ new jqx.dataAdapter({
                                        localData: listContracts,
                                        dataType: 'array',
                                        dataFields: getDataFields(),
                                        id: 'id'
                                    })}
                                    columns={getColumns()}
                                    onCellvaluechanged={onCellvaluechanged} 
                                    onFilter={(event) => handlerFilter(event, 'Contract')}
                                />
                            </>
                        }
                    </div>
                </Card.Body>
            </Card>
            {
                listContractsProps &&
                <SidePanelConfigureProps
                    inputParam_IsPanelOpen={isPanelConfigurePropsOpen}
                    inputParam_SetterIsPanelOpen={setIsPanelConfigurePropsOpen}
                    inputParam_ListContracts={listContracts}
                    inputParam_SetterListContracts={setListContracts}
                />
            }      
        </div>
    ); 
}